// extracted by mini-css-extract-plugin
export var fb = "social-module--fb--P1b4X social-module--icon--TtvQK";
export var fl = "social-module--fl--B3jit social-module--icon--TtvQK";
export var icon = "social-module--icon--TtvQK";
export var iconWidth = "-36px";
export var ig = "social-module--ig--qbpWR social-module--icon--TtvQK";
export var rs = "social-module--rs--H8LJW social-module--icon--TtvQK";
export var th = "social-module--th--hz2I6 social-module--icon--TtvQK";
export var tu = "social-module--tu--lor-k social-module--icon--TtvQK";
export var tw = "social-module--tw--ZvIRX social-module--icon--TtvQK";
export var yt = "social-module--yt--rqyT0 social-module--icon--TtvQK";